import { THIRD_PARTY_LINKS_BASE_URL } from '@/config/env';
import { useOpenExternalLink } from '@/hooks/useOpenExternalLink';
import type { DiaryThirdPartyEvent } from '@/types/diary';

export const useOpenThirdPartyEvent = () => {
  const openExternalLink = useOpenExternalLink();

  return (event: DiaryThirdPartyEvent) =>
    openExternalLink({
      url: `${THIRD_PARTY_LINKS_BASE_URL}${event.url}`,
      isSingleSignOn: true,
    });
};
